import { createFileRoute } from "@tanstack/react-router";
import { OnboardingTemplatePage } from "@/features/onbtemplate/OnboardingTemplatePage";

export const Route = createFileRoute("/_app/onboarding/templates/$template")({ component: Page });

function Page() {
  const { template } = Route.useParams();
  return <OnboardingTemplatePage id={template} />;
}
